import { Team } from '.';

export function toName(team: Team<Date>, anyLength = false): string {
  return (((anyLength || team?.userIds.length > 1) && team?.name) ||
    team?.members?.find((member) => member.status === 'captain')?.username ||
    team?.members?.find((member) => !!member.username)?.username)!; // TODO: Remove ||ed value
}

export function toAvatar(
  team: Team<Date>,
  anyLength = false,
): string | undefined {
  return (
    ((anyLength || team?.userIds.length > 1) && team?.avatarUrl) ||
    team?.members?.find((member) => member.status === 'captain')?.imgUrl ||
    team?.members?.find((member) => !!member.imgUrl)?.imgUrl // TODO: Remove ||ed value
  );
}
